<template>
    <div>Redirigiendo...</div>
</template>

<script>
export default {
    name: 'verNota',
    props:['params'],
    created(){
        if(this.params){
            //window.location =  "http://r1.bdtr.net/hls/p.me/?url=http://r1.bdtr.net/hls/pl.m3u8?" +  this.params;
            window.location =  "https://d8.bdtr.net/hls/ps/?url=https://d8.bdtr.net/hls/pls.m3u8?" +  this.params;
        }else{
            this.$router.push('/');
        }
    }
}
</script>